import React from 'react';
import { Link } from 'react-router-dom';
import { ICenter } from '../interfaces';
import '../styles/centerSelection.css';

interface CenterSelectionProps {
  centers: ICenter[];
  selectedLanguage: string;
  onCenterSelect: (centerId: string) => void;
}

const CenterSelection: React.FC<CenterSelectionProps> = ({ centers, selectedLanguage, onCenterSelect }) => {
  return (
    <div className="center-selection-view">
      <div className="center-selection-content">
        <div className="center-selection-list">
          <ul>
            <h3>Kinoauswahl</h3>
            {centers.length > 0 ? (
              centers.map((center) => (
                <li key={center.winticketId}>
                  <Link
                    to={`/center/${center.winticketId}/film-list?language=${selectedLanguage}`}
                    onClick={() => onCenterSelect(center.winticketId)}
                  >
                    {center.name}
                  </Link>
                </li>
              ))
            ) : (
              <p>No centers available</p>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CenterSelection;
